import React from 'react';
import Rocket from 'src/data/images/new_rocket.svg';
import { mediaQueries } from 'src/style/breakpoints';

export const RocketIllustration = () => {
  return (
    <div
      css={{
        position: 'absolute',
        top: -120,
        width: '100%',
        left: 0,
        height: 190,
        zIndex: 3,
        [mediaQueries.tabletPortraitUp]: {
          top: -190,
          height: 295,
        },
      }}
    >
      <div
        css={{
          backgroundImage: `url(${Rocket})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          width: '100%',
          height: '100%',
        }}
      />
    </div>
  );
};
export default RocketIllustration;
